module.exports = __webpack_public_path__ + "static/media/Omni_grey.d0958052.svg";